import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { PracticeInscription } from 'src/app/interfaces/practiceinscription';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorService } from 'src/app/services/error.service';
import { PracticeInscriptionService } from 'src/app/services/practiceinscription.service';

@Component({
  selector: 'app-practiceinscription',
  templateUrl: './practiceinscription.component.html',
  styleUrls: ['./practiceinscription.component.css']
})
export class PracticeinscriptionComponent implements OnInit {
  listPractices: PracticeInscription[] = [];
  filteredPractices: PracticeInscription[] = [];
  loading = false;

  constructor(
    private _practiceinscriptionService: PracticeInscriptionService,
    private toastr: ToastrService,
    public authService: AuthService,
    private _errorService: ErrorService
  ) {}

  ngOnInit(): void {
    if (this.authService.rol === 1) {
      this.getListPractices();
      return;
    }

    this.getListPracticeInscriptionsByStudentV2();
  }

  onSearch(event: Event) {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase().trim();

    if (!searchTerm) {
      this.filteredPractices = [...this.listPractices];
      return;
    }

    this.filteredPractices = this.listPractices.filter((practice) =>
      practice.namestudent?.toLowerCase().includes(searchTerm) ||
      practice.lastname?.toLowerCase().includes(searchTerm) ||
      practice.namecareer?.toLowerCase().includes(searchTerm) ||
      practice.namecenter?.toLowerCase().includes(searchTerm) ||
      practice.namearea?.toLowerCase().includes(searchTerm) ||
      practice.nameturn?.toLowerCase().includes(searchTerm) ||
      practice.namemanagement?.toLowerCase().includes(searchTerm)
    );
  }

  getListPractices() {
    this.loading = true;
    this._practiceinscriptionService.getListPracticeInscriptions().subscribe({
      next: (data: PracticeInscription[]) => {
        const normalizedData = data.map((item) => this.normalizePractice(item));
        this.listPractices = normalizedData;
        this.filteredPractices = [...normalizedData];
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener la lista de inscripciones de practicas:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  deletePractice(id: number) {
    this.loading = true;
    this._practiceinscriptionService.deletePracticeInscription(id).subscribe({
      next: () => {
        this.toastr.warning('La inscripcion de practica fue eliminada con exito', 'Practica eliminada');
        this.getListPractices();
      },
      error: (error) => {
        console.error('Error al eliminar la practica:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  updatePracticeInscriptionState(id: number, state: number) {
    const newStatus = state === 0 ? 1 : 0;
    this.loading = true;

    this._practiceinscriptionService.updatePracticeInscriptionState(id, { state: newStatus }).subscribe({
      next: () => {
        this.getListPractices();
        const practiceMessage = newStatus === 0 ? 'deshabilitada' : 'habilitada';
        this.toastr.warning(`La inscripcion fue ${practiceMessage} con exito`, 'Inscripcion actualizada');
      },
      error: (error) => {
        console.error('Error al actualizar el estado de la practica:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  getListPracticeInscriptionsByStudentV2() {
    const studentId = this.authService.idstudent;
    if (!studentId) {
      this.toastr.error('No se encontro un estudiante valido para esta sesion', 'Error');
      return;
    }

    this.loading = true;
    this._practiceinscriptionService.getPracticeInscriptionsByStudentIdV2(studentId).subscribe({
      next: (data: PracticeInscription[]) => {
        const normalizedData = data.map((item: any) => this.normalizePractice(item));
        this.listPractices = normalizedData;
        this.filteredPractices = [...normalizedData];
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener las inscripciones de practicas:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  deleteAllPracticeInscriptions() {
    if (confirm('Esta seguro de que desea eliminar todas las inscripciones de practica? Esta accion no se puede deshacer.')) {
      this.loading = true;
      this._practiceinscriptionService.deleteAllPracticeInscriptions().subscribe({
        next: () => {
          this.toastr.warning('Todas las inscripciones fueron eliminadas con exito', 'Inscripciones eliminadas');
          this.getListPractices();
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al eliminar todas las inscripciones:', error);
          this._errorService.msjError(error);
          this.loading = false;
        }
      });
    }
  }

  exportToExcel() {
    const filteredData = this.filteredPractices.map((practice) => ({
      Gestion: practice.namemanagement,
      Nombres: practice.namestudent,
      Apellidos: practice.lastname,
      Carrera: practice.namecareer,
      Centro: practice.namecenter,
      Area: practice.namearea,
      Turno: practice.nameturn,
      Vacantes: practice.quota,
      Inscritos: practice.enrolled
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Listado de Practicas': worksheet },
      SheetNames: ['Listado de Practicas']
    };

    XLSX.writeFile(workbook, 'Listado_Practicas.xlsx');
  }

  private normalizePractice(item: any): PracticeInscription {
    return {
      ...item,
      namemanagement: item.namemanagement || item.practice?.management?.name || null,
      namecareer: item.namecareer || item.practice?.career?.name || null,
      namearea: item.namearea || item.practice?.areaCenter?.area?.name || null,
      namecenter: item.namecenter || item.practice?.areaCenter?.center?.name || null,
      nameturn: item.nameturn || item.practice?.areaCenter?.turn?.name || null,
      namestudent: item.namestudent || item.student?.name || null,
      lastname: item.lastname || item.student?.lastname || null,
      quota: item.quota || item.practice?.quota || null,
      enrolled: item.enrolled || item.practice?.enrolled || null
    };
  }
}
